export default __webpack_public_path__ + "static/media/img4.d4f847c5.png";